import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const WelcomePage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleNext = () => {
    navigate('/form');
  };

  const handleViewSubmissions = () => {
    navigate('/doctors');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="container">
      {/* Header with logout */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        marginBottom: '20px' 
      }}>
        <button
          onClick={handleLogout}
          style={{
            background: 'none',
            border: 'none',
            color: '#666',
            cursor: 'pointer',
            fontSize: '14px',
            padding: '8px'
          }}
        >
          Logout
        </button>
      </div>

      {/* Welcome content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div className="page-header">
          <div style={{ 
            width: '80px', 
            height: '80px', 
            backgroundColor: '#1f84f1', 
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            boxShadow: '0 4px 20px rgba(31, 132, 241, 0.3)'
          }}>
            <span style={{ fontSize: '32px' }}>🌟</span>
          </div>
          <h1 className="page-title">Welcome, {user?.mr_name || 'User'}!</h1>
        </div>

        {/* Welcome message card */}
        <div className="card" style={{ marginBottom: '32px' }}>
          <p style={{ 
            fontSize: '16px', 
            lineHeight: '1.6', 
            color: '#333',
            marginBottom: '16px'
          }}>
            You're about to create a personalized <strong>Cosmic Profile</strong> for a doctor.
            This unique astrological frame captures their celestial blueprint based on their
            birth details.
          </p>

          {/* Important note - bold */}
          <div style={{
            backgroundColor: '#fff8e6',
            border: '1px solid #ffd700',
            borderRadius: '8px',
            padding: '16px',
            marginTop: '16px'
          }}>
            <p style={{ 
              fontSize: '14px', 
              color: '#333',
              fontWeight: '600',
              marginBottom: '8px'
            }}>
              <span style={{ marginRight: '8px' }}>⚠️</span>
              <strong>Important Note:</strong>
            </p>
            <p style={{ 
              fontSize: '14px', 
              color: '#555',
              lineHeight: '1.5'
            }}>
              <strong>Please ensure you enter accurate birth details</strong> (date, time, and place).
              The cosmic profile is generated based on these details and <strong>cannot be modified
              once created</strong>.
            </p>
          </div>
        </div>

        {/* What you'll need */}
        <div style={{ marginBottom: '32px' }}>
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: '600', 
            color: '#333',
            marginBottom: '16px'
          }}>
            What you'll need:
          </h3>
          <ul style={{ 
            listStyle: 'none', 
            padding: 0,
            margin: 0
          }}>
            {[
              "Doctor's full name",
              "Date of birth",
              "Place of birth (City)",
              "Time of birth"
            ].map((item, index) => (
              <li 
                key={index}
                style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: index < 3 ? '1px solid #eee' : 'none'
                }}
              >
                <span style={{ 
                  color: '#1f84f1',
                  marginRight: '12px',
                  fontWeight: 'bold'
                }}>
                  ✓
                </span>
                <span style={{ color: '#333' }}>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Actions */}
        <div style={{ marginBottom: '24px' }}>
          <button
            onClick={handleNext}
            className="btn btn-primary"
            style={{ marginBottom: '12px' }}
          >
            ADD DOCTOR
          </button>
          <button
            onClick={handleViewSubmissions}
            className="btn btn-secondary"
          >
            VIEW SUBMISSIONS
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
